import { axios } from "utilities/axios";
import { createGetAllPaginatedItems } from "@edgetier/utilities";

/**
 * Get all items for a paginated URL.
 * @param url URL to request.
 */
export const getAllPaginatedItems = createGetAllPaginatedItems(axios);
